import createIcon from '../../createIcon';

/**
 * @component @name LocalDrink
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAyTDUuMDEgMjAuMjNDNS4xMyAyMS4yMyA1Ljk3IDIyIDcgMjJIMTdDMTguMDMgMjIgMTguODcgMjEuMjMgMTguOTkgMjAuMjNMMjEgMkgzWk0xMiAxOUMxMC4zNCAxOSA5IDE3LjY2IDkgMTZDOSAxNCAxMiAxMC42IDEyIDEwLjZDMTIgMTAuNiAxNSAxNCAxNSAxNkMxNSAxNy42NiAxMy42NiAxOSAxMiAxOVpNMTguMzMgOEg1LjY3TDUuMjMgNEgxOC43NkwxOC4zMyA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalDrink = createIcon('LocalDrink', [
  [
    'path',
    {
      d: 'M3 2L5.01 20.23C5.13 21.23 5.97 22 7 22H17C18.03 22 18.87 21.23 18.99 20.23L21 2H3ZM12 19C10.34 19 9 17.66 9 16C9 14 12 10.6 12 10.6C12 10.6 15 14 15 16C15 17.66 13.66 19 12 19ZM18.33 8H5.67L5.23 4H18.76L18.33 8Z',
      key: '1exy5y',
    },
  ],
]);

export default LocalDrink;
